import rangeSelectRowInternal from './rangeSelectRowInternal';
import singleSelectRowInternal from './singleSelectRowInternal';
import { SelectionDirection } from 'owa-mail-list-store';
import { trace } from 'owa-trace';
export default function selectRowInDirection(tableView, selectionDirection, rowKey, mailListItemSelectionSource, isRangeSelection) {
    var tableRowKeys = tableView.rowKeys;
    var selectedIndex = tableRowKeys.indexOf(rowKey);
    if (selectedIndex < 0) {
        trace.error('Invalid selectedIndex');
        return;
    }
    else if ((selectedIndex == 0 && selectionDirection == SelectionDirection.Previous) ||
        (selectedIndex == tableRowKeys.length - 1 && selectionDirection == SelectionDirection.Next)) {
        return;
    }
    switch (selectionDirection) {
        case SelectionDirection.Next:
            selectedIndex++;
            break;
        case SelectionDirection.Previous:
            selectedIndex--;
            break;
    }
    var tableRowKey = tableRowKeys[selectedIndex];
    if (isRangeSelection) {
        rangeSelectRowInternal(tableView, tableRowKey, mailListItemSelectionSource);
    }
    else {
        singleSelectRowInternal(tableView, tableRowKey, true /* isUserNavigation */, mailListItemSelectionSource);
    }
}
//# sourceMappingURL=selectRowInDirection.js.map